import Link from '@tiptap/extension-link';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import { cn } from '../../utils/cn.js';

const RichTextViewer = ({ value, className, removeClass = false }) => {
  const editor = useEditor(
    {
      editorProps: {
        attributes: {
          class: cn(
            className,
            !removeClass &&
              'min-h-[150px] max-h-[150px] w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 overflow-auto bg-background',
          ),
        },
      },
      editable: false,
      extensions: [
        Link.configure({
          openOnClick: true,
          autolink: true,
          defaultProtocol: 'https',
          HTMLAttributes: {
            class: 'underline cursor-pointer',
          },
        }),

        StarterKit.configure({
          orderedList: {
            HTMLAttributes: {
              class: 'list-decimal pl-4',
            },
          },
          bulletList: {
            HTMLAttributes: {
              class: 'list-disc pl-4',
            },
          },
        }),
      ],
      content: value,
    },
    [value],
  );

  return (
    <div className="rich-text-class">
      <EditorContent editor={editor} />
    </div>
  );
};

export default RichTextViewer;
